var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-field form-field__input form-field__select",
      class: _vm.rootClasses
    },
    [
      _c("label", [
        _vm.$slots.label
          ? _c(
              "div",
              { staticClass: "form-field--title-label" },
              [_vm._t("label")],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-field--input-container",
            attrs: {
              "data-action-count": _vm.countVirtualtags(_vm.$slots.actions) || 1
            }
          },
          [
            _c(
              "select",
              _vm._g(
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentValue,
                        expression: "currentValue"
                      }
                    ],
                    staticClass: "form-field--input",
                    on: {
                      focus: _vm.onFocus,
                      blur: _vm.onBlur,
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.currentValue = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  "select",
                  _vm.$attrs,
                  false
                ),
                _vm.$listeners
              ),
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "ui-actions",
              [
                _vm._t("actions", [
                  _c("ui-icon", _vm._b({}, "ui-icon", _vm.icon, false))
                ])
              ],
              2
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._t("messages")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64b90dbb", { render: render, staticRenderFns: staticRenderFns })
  }
}